export default __webpack_public_path__ + "static/media/business-item-3.ab808dbc.jpg";